(function () {
  var root = document.querySelector('[data-nq]');
  if (!root) return;

  var DATA = JSON.parse(document.getElementById('nq-data').textContent);
  var TOTAL = parseInt(root.dataset.total, 10) || 8;
  var screens = {};
  root.querySelectorAll('[data-screen]').forEach(function (s) { screens[s.dataset.screen] = s; });
  var qs = root.querySelectorAll('.nq-q');
  var answers = [];
  var current = 0;
  var result = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = k !== name; });
    var top = root.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  function showQuestion(i) {
    current = i;
    qs.forEach(function (q, k) { q.hidden = k !== i; });
    var n = pad(i + 1) + ' / ' + pad(TOTAL);
    root.querySelector('[data-count]').textContent = n;
    root.querySelector('[data-step]').textContent = 'Question ' + n;
    var bar = root.querySelector('.nq-bar');
    bar.setAttribute('aria-valuenow', i + 1);
    root.querySelector('[data-bar]').style.width = ((i + 1) / TOTAL * 100) + '%';
    var picked = answers[i];
    qs[i].querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === picked; });
    qs[i].querySelector('legend').focus({ preventScroll: true });
  }

  function score() {
    var count = {};
    var last = {};
    answers.forEach(function (a, i) { count[a] = (count[a] || 0) + 1; last[a] = i; });
    var best = null;
    Object.keys(count).forEach(function (k) {
      if (best === null || count[k] > count[best] || (count[k] === count[best] && last[k] > last[best])) best = k;
    });
    return best;
  }

  function showResult() {
    result = score();
    var d = DATA[result];
    root.querySelector('[data-r-name]').textContent = d.name;
    root.querySelector('[data-r-tag]').textContent = d.tag;
    root.querySelector('[data-r-body]').textContent = 'You are The ' + d.name + '. ' + d.body;
    root.querySelector('[data-r-exp]').textContent = d.exp;
    show('result');
    root.querySelector('.nq-name').focus({ preventScroll: true });
    drawCard();
    if (window.dataLayer) window.dataLayer.push({ event: 'quiz_complete', quiz_result: result });
  }

  root.querySelector('[data-start]').addEventListener('click', function () {
    answers = [];
    show('play');
    showQuestion(0);
  });

  root.querySelector('[data-back]').addEventListener('click', function () {
    if (current === 0) { show('start'); return; }
    showQuestion(current - 1);
  });

  root.querySelector('.nq-form').addEventListener('change', function (e) {
    if (!e.target.matches('input[type=radio]')) return;
    answers[current] = e.target.value;
    setTimeout(function () {
      if (current < TOTAL - 1) showQuestion(current + 1);
      else showResult();
    }, reduce ? 0 : 320);
  });

  root.querySelector('[data-retake]').addEventListener('click', function () {
    answers = [];
    show('start');
  });

  /* ---------- Story card (1080 x 1920) ---------- */
  var canvas = root.querySelector('[data-canvas]');
  var ctx = canvas.getContext('2d');

  function wrap(text, x, y, maxW, lh) {
    var words = text.split(' '), line = '';
    words.forEach(function (w) {
      var t = line ? line + ' ' + w : w;
      if (ctx.measureText(t).width > maxW && line) { ctx.fillText(line, x, y); line = w; y += lh; }
      else line = t;
    });
    ctx.fillText(line, x, y);
    return y;
  }

  function spaced(text, x, y, gap) {
    var total = 0, i;
    for (i = 0; i < text.length; i++) total += ctx.measureText(text[i]).width + gap;
    total -= gap;
    var cx = x - total / 2;
    ctx.textAlign = 'left';
    for (i = 0; i < text.length; i++) { ctx.fillText(text[i], cx, y); cx += ctx.measureText(text[i]).width + gap; }
    ctx.textAlign = 'center';
  }

  function paint() {
    var d = DATA[result], W = 1080, H = 1920, cx = W / 2;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = '#101012';
    ctx.fillRect(0, 0, W, H);
    var g = ctx.createRadialGradient(150, 100, 0, 150, 100, 1300);
    g.addColorStop(0, 'rgba(110,20,45,.7)'); g.addColorStop(1, 'rgba(16,16,18,0)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    g = ctx.createRadialGradient(1000, 1850, 0, 1000, 1850, 1200);
    g.addColorStop(0, 'rgba(74,21,38,.85)'); g.addColorStop(1, 'rgba(16,16,18,0)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    ctx.strokeStyle = 'rgba(184,154,99,.55)'; ctx.lineWidth = 2;
    ctx.strokeRect(48, 48, W - 96, H - 96);

    ctx.textAlign = 'center';
    ctx.fillStyle = '#F1E9DD';
    ctx.font = '500 30px Montserrat, sans-serif';
    spaced('NORA VELLICK', cx, 190, 12);

    ctx.fillStyle = '#B89A63';
    ctx.font = '500 28px Montserrat, sans-serif';
    spaced('I GOT', cx, 640, 10);
    ctx.fillRect(cx - 40, 690, 80, 2);

    ctx.fillStyle = '#F1E9DD';
    ctx.font = 'italic 400 120px "Playfair Display", Georgia, serif';
    ctx.fillText('The', cx, 850);
    var size = 170;
    do { ctx.font = '400 ' + size + 'px "Playfair Display", Georgia, serif'; size -= 6; }
    while (ctx.measureText(d.name).width > W - 200 && size > 80);
    ctx.fillText(d.name, cx, 1030);

    ctx.fillStyle = 'rgba(241,233,221,.85)';
    ctx.font = '400 38px Montserrat, sans-serif';
    wrap(d.tag, cx, 1180, 780, 58);

    ctx.fillStyle = '#B89A63';
    ctx.fillRect(cx - 40, 1450, 80, 2);
    ctx.fillStyle = '#F1E9DD';
    ctx.font = 'italic 400 64px "Playfair Display", Georgia, serif';
    ctx.fillText('What did you get?', cx, 1560);
    ctx.fillStyle = '#B89A63';
    ctx.font = '500 28px Montserrat, sans-serif';
    spaced((root.dataset.domain + '/pages/quiz').toUpperCase(), cx, 1700, 6);
  }

  function drawCard() {
    var ready = document.fonts && document.fonts.load
      ? Promise.all([
          document.fonts.load('400 100px "Playfair Display"'),
          document.fonts.load('italic 400 100px "Playfair Display"'),
          document.fonts.load('500 30px Montserrat')
        ]).catch(function () {})
      : Promise.resolve();
    ready.then(paint);
  }

  function toBlob() {
    return new Promise(function (res) { canvas.toBlob(res, 'image/png'); });
  }
  var shareMsg = root.querySelector('[data-share-msg]');

  function download() {
    toBlob().then(function (b) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(b);
      a.download = 'my-nora-vellick-result.png';
      document.body.appendChild(a); a.click(); a.remove();
      shareMsg.textContent = 'Saved. Add it to your Story from your camera roll.';
    });
  }
  root.querySelector('[data-download]').addEventListener('click', download);
  root.querySelector('[data-share]').addEventListener('click', function () {
    toBlob().then(function (b) {
      var file = new File([b], 'my-nora-vellick-result.png', { type: 'image/png' });
      var text = 'I got The ' + DATA[result].name + '. What did you get?';
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator.share({ files: [file], text: text, url: location.origin + location.pathname }).catch(function () {});
      } else {
        download();
      }
    });
  });
})();
